import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from "./layout/Layout";
import DefaultHeader2 from "./layout/header";
import Login from "./components/accounts/login";
import Register from "./components/accounts/register";
import AdminDashboard from "./components/dbadmin/dashboard-area";
import Cities from "./components/dbadmin/city";
import Management from "./components/dbadmin/manager";
import ManageDonors from "./components/donormanagement/dashboard";
import DonorManagement from "./components/dbadmin/donors";
import DonorList from "./components/donormanagement/donorlist";
import BloodDonations from "./components/donormanagement/donationcollection";
import LiveDashboard from "./components/accounts/livedashboard";
import IssuedBloodBags from "./components/donormanagement/IssuedBloodBags";
import Districts from "./components/dbadmin/Districts";
import ShelfLifeSettings from "./components/dbadmin/ShelfLifeSettings";
import DonationLimitList from './components/dbadmin/donationlimit';
import ProtectedRoute from "./ProtectedRoute";

function Home() {
  const user = getCurrentUser();

  if (user?.role === "csr") return <Navigate to="/csr/dashboard" replace />;
  if (user?.role === "admin") return <Navigate to="/admin/dashboard-area" replace />;

  return <LiveDashboard />;
}

function getCurrentUser() {
  try {
    const raw = localStorage.getItem("awt_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function App() {
  return (
    <BrowserRouter>
      <DefaultHeader2 />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/livedashboard" element={<Layout><LiveDashboard /></Layout>} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Admin-only routes */}
        <Route path="/admin/dashboard-area" element={
          <ProtectedRoute allowedRoles={["admin"]}><AdminDashboard /></ProtectedRoute>
        } />
        <Route path="/admin/city" element={
          <ProtectedRoute allowedRoles={["admin"]}><Cities /></ProtectedRoute>
        } />
        <Route path="/admin/Districts" element={
          <ProtectedRoute allowedRoles={["admin"]}><Districts /></ProtectedRoute>
        } />
        <Route path="/admin/manager" element={
          <ProtectedRoute allowedRoles={["admin"]}><Management /></ProtectedRoute>
        } />
        <Route path="/admin/donors" element={
          <ProtectedRoute allowedRoles={["admin"]}><DonorManagement /></ProtectedRoute>
        } />
        <Route path="/admin/ShelfLifeSettings" element={
          <ProtectedRoute allowedRoles={["admin"]}><ShelfLifeSettings /></ProtectedRoute>
        } />
        <Route path="/admin/donationlimits" element={
          <ProtectedRoute allowedRoles={["admin"]}><DonationLimitList /></ProtectedRoute>
        } />

        {/* CSR-only routes */}
        <Route path="/csr/dashboard" element={
          <ProtectedRoute allowedRoles={["csr"]}><ManageDonors /></ProtectedRoute>
        } />
        <Route path="/csr/donorlist" element={
          <ProtectedRoute allowedRoles={["csr"]}><DonorList /></ProtectedRoute>
        } />
        <Route path="/csr/donationcollection" element={
          <ProtectedRoute allowedRoles={["csr"]}><BloodDonations /></ProtectedRoute>
        } />
        <Route path="/csr/IssuedBloodBags" element={
          <ProtectedRoute allowedRoles={["csr"]}><IssuedBloodBags /></ProtectedRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;